import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Carousel, CarouselStatus } from "@domain/carousel/carousel";
import { useMyCarousels } from "@domain/carousel/hooks";
import { useIsMobile } from "@utils/hooks";
import { Secondary } from "@ui/components/containers/textBlocks";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { stack } from "@ui/components/layout";
import { CarouselThumbnail } from "@ui/components/pdfCarousel/carouselThumbnail";
import { desktop, mobile } from "@ui/styles/utils";

interface MyCarouselsListProps extends React.HTMLAttributes<HTMLDivElement> {
	status: CarouselStatus | "ALL";
}

export const MyCarouselsList: React.FC<MyCarouselsListProps> = ({ status, ...htmlProps }) => {
	const { result: carousels, fetchMore, loading, moreLoading, totalElements } = useMyCarousels(status);
	const isMobile = useIsMobile();
	const isMedium = isMobile ? false : true;

	return (
		<Container>
			{totalElements === 0 ? (
				<Secondary>
					{I18n.t(status === "ALL" ? "profile.carousel_self.empty_all" : "profile.carousel_self.empty")}
				</Secondary>
			) : (
				<InfiniteScroll onEndReached={fetchMore} loading={loading || moreLoading}>
					<Carousels {...htmlProps}>
						{carousels.map((carousel: Carousel) =>
							carousel ? <CarouselThumbnail key={carousel.id} medium={isMedium} carousel={carousel} /> : undefined
						)}
						{loading && <ClipLoader />}
					</Carousels>
				</InfiniteScroll>
			)}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Carousels = styled.div`
	@media ${desktop} {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 20px;
	}
	@media ${mobile} {
		${stack(20, "center", "center")}
	}
`;
